/**
 * useFeatureFlag — consulta fn_is_feature_enabled via RPC com cache 5 min.
 *
 * Sprint QQ. Identico ao web-admin (poderia ir para shared mas o shared
 * é React-agnostico).
 */
import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';

export function useFeatureFlag(
  cod_feature: string,
  options?: { fallback?: boolean },
): boolean | undefined {
  const fallback = options?.fallback ?? false;

  const { data, isLoading } = useQuery({
    queryKey: ['feature-flag', cod_feature],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('fn_is_feature_enabled', {
        p_cod_feature: cod_feature,
      });
      if (error) {
        console.warn(`[feature-flag] ${cod_feature} falhou:`, error.message);
        return fallback;
      }
      return data as boolean;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  if (isLoading) return undefined;
  return (data as boolean | undefined) ?? fallback;
}
